<template>
  <div class="cr-login">
    <div class="cr-container">
      <div class="cr-login__wrapper">
        <div class="cr-login__section">
          <div class="cr-login__top">
            На указанный телефон<br>
            будет отправлен код подтверждения
          </div>
          <div class="cr-login__main">
            <div v-if="serverError" class="cr-detail-card__message cr-message cr-message--error" v-html="serverError"></div>
            <form v-if="step==1" @submit.prevent="getCode" class="cr-login__form cr-form" method="post" autocomplete="off">
              <fieldset class="cr-form__fieldset">
                <div class="cr-form__field">
                  <label class="cr-form__label" for="phone">
                    Телефон
                    <span class="cr-form__asterisk">
                                                *
                                            </span>
                  </label>
                  <MaskInput class="cr-form__input"  v-model="formData.phone" mask="+7 (###) ###-##-##" placeholder="+7 ( _ _ _ ) _ _ _-_ _-_ _" required />
                </div>
              </fieldset>
              <div class="cr-form__bottom">
                <button class="cr-button" type="submit">
                                        <span class="cr-button__text">
                                            Получить код
                                        </span>
                </button>
              </div>
            </form>
            <form v-if="step==2" @submit.prevent="auth" class="cr-login__form cr-form" method="post" autocomplete="off">
              <fieldset class="cr-form__fieldset">
                <div class="cr-form__field">
                  <label class="cr-form__label" for="phone">
                    Телефон
                    <span class="cr-form__asterisk">
                                                *
                                            </span>
                  </label>
                  <input readonly :value="formData.phone" class="cr-form__input" type="tel" id="phone" name="phone" placeholder="+7 ( _ _ _ ) _ _ _-_ _-_ _" required>
                </div>
                <div class="cr-form__field field_code">
                  <label class="cr-form__label" for="code">
                    Код
                    <span class="cr-form__asterisk">
                                                *
                                            </span>
                  </label>
                  <MaskInput ref="code" class="cr-form__input" v-model="formData.code" mask="####" placeholder="____" required />
                </div>
              </fieldset>
              <div class="cr-form__bottom">
                <button class="cr-button" type="submit">
                                        <span class="cr-button__text">
                                            Подтвердить
                                        </span>
                </button>
                <div class="cr-form__note" v-if="!canResendCode">
                  Отправить код еще раз через {{ formattedRemainingTime }}
                </div>
                <button
                    class="cr-button cr-button--light"
                    type="button"
                    @click="resendCode"
                    :disabled="!canResendCode"
                    v-if="canResendCode">
                  <span class="cr-button__text">
                    Отправить код еще раз
                  </span>
                </button>
              </div>
            </form>
          </div>
          <div class="cr-login__bottom">
            <div class="cr-login__note">
              Ещё нет аккаунта?
            </div>
            <router-link class="cr-link" to="/registration/">
              Оставьте заявку на регистрацию
            </router-link>
          </div>
        </div>
        <div class="cr-login__section">
          <Menu></Menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { MaskInput } from 'vue-3-mask';
import scrollToError from "@/mixin/scrollToError.vue";
import Menu from "./components/Menu"

export default {
  components: {
    MaskInput, Menu
  },
  mixins: [scrollToError],
  beforeRouteLeave(to, from) {
    //if (to.name != 'login')
    //  this.$store.dispatch('unLoader');
  },
  created() {

  },
  computed: {
    formattedRemainingTime() {
      const minutes = Math.floor(this.remainingTime / 60);
      const seconds = this.remainingTime % 60;
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }

  },
  async mounted() {

  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    validateForm() {
      this.errors = {};

      // Validate phone - with mask we can simplify the validation
      if (!this.formData.phone) {
        this.step = 1;
        return false;
      } else if (this.formData.phone.includes('_')) {
        this.step = 1;
        return false;
      }

      // Validate surname
      if (!this.formData.surname.trim()) {
        this.errors.surname = 'Фамилия обязательна';
      } else if (this.formData.surname.length < 2) {
        this.errors.surname = 'Фамилия должна содержать минимум 2 символа';
      }

      // Validate name
      if (!this.formData.name.trim()) {
        this.errors.name = 'Имя обязательно';
      } else if (this.formData.name.length < 2) {
        this.errors.name = 'Имя должно содержать минимум 2 символа';
      }

      // Validate email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.formData.email.trim()) {
        this.errors.email = 'Email обязателен';
      } else if (!emailRegex.test(this.formData.email)) {
        this.errors.email = 'Некорректный формат email';
      }



      // Validate birth date
      const day = parseInt(this.formData.day);
      const year = parseInt(this.formData.year);

      if (!day || !year) {
        this.errors.birthdate = 'Дата рождения обязательна';
      } else if (day < 1 || day > 31) {
        this.errors.birthdate = 'Некорректный день';
      } else if (year < 1900 || year > new Date().getFullYear()) {
        this.errors.birthdate = 'Некорректный год';
      }

      const isValid = Object.keys(this.errors).length === 0;

      if (!isValid) {
        this.scrollToFirstError();
      }

      return isValid;
    },
    getCode: function(e) {
      if (this.sending === true)
        return;
      let formData = new FormData(),
          _this = this;
      let top = 0;
      this.error = [];
      this.error_text = [];
      this.errors = {};
      this.serverError= '';

      formData.append('phone', this.formData.phone);

      if (!this.formData.phone) {
        this.error.push('phone');
        this.errors.phone = 'Не заполнено';
        top = document.querySelector(".field_phone").offsetTop;
      }

      if (this.error.length == 0) {
        this.sending = true;
        axios.post( 'api/user/sms/',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
        ).then(function(response){
          if (response.data.status == 'success') {
            _this.step=2;
            _this.sending = false;
            // Запускаем таймер с временем ожидания из ответа сервера
            _this.startResendTimer(response.data.data.wait || 300); // 300 секунд (5 минут) по умолчанию
            _this.$nextTick(() => {
              document.querySelector(".field_code input").focus()
            });
          }
          else {
            _this.serverError= '';
            for (let i in response.data.errors) {
              console.log(typeof response.data.errors[i].code)
              if (typeof response.data.errors[i].code == 'number') {
                _this.serverError = 'Ошибка сервера.';
                break;
              }
              else
                _this.serverError += response.data.errors[i].message+"<br>";
            }
            _this.sending = false;
          }
        })
            .catch(function(){
              _this.sending = false;
            });
      }
      else {
        window.scrollTo(0, top);
      }
    },
    auth: function(e) {
      if (this.sending === true)
        return;
      let formData = new FormData(),
          _this = this;
      let top = 0;
      this.error = [];
      this.error_text = [];
      this.errors = {};
      this.serverError = '';

      formData.append('phone', this.formData.phone);
      formData.append('code', this.formData.code);

      if (!this.formData.code) {
        this.error.push('code');
        top = document.querySelector(".field_code").offsetTop;
      }
      if (!this.formData.phone) {
        this.error.push('phone');
        top = document.querySelector(".field_phone").offsetTop;
      }

      if (this.error.length == 0) {
        formData.append('uuid', this.$store.getters.device_uuid);
        this.sending = true;
        axios.post( 'api/user/login/',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
        ).then(function(response){
          if (response.data.status == 'success') {

              let data = response.data.data;
              data.device = _this.$store.getters.device;
              data.uuid = _this.$store.getters.device_uuid;
              _this.$store.dispatch('Auth', data)
              _this.$router.push('/personal/');
            _this.sending = false;
          }
          else {
            _this.serverError= '';
            for (let i in response.data.errors) {
              console.log(typeof response.data.errors[i].code)
              if (typeof response.data.errors[i].code == 'number') {
                _this.serverError = 'Ошибка сервера.';
                break;
              }
              else
                _this.serverError += response.data.errors[i].message+"<br>";
            }
            _this.sending = false;
          }
        })
            .catch(function(){
              _this.sending = false;
            });
      }
      else {
        window.scrollTo(0, top);
      }
    },
    startResendTimer(waitTime) {
      this.remainingTime = waitTime;
      this.canResendCode = false;

      if (this.timer) {
        clearInterval(this.timer);
      }

      this.timer = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--;
        } else {
          this.canResendCode = true;
          clearInterval(this.timer);
        }
      }, 1000);
    },

    resendCode() {
      if (!this.canResendCode || this.sending) return;
      this.getCode();
    }

  },
  data: () => ({
    error: [],
    errors: {},
    sending: false,
    error_text: [],
    step: 1,
    formData: {
      code: '',
      surname: '',
      name: '',
      patronymic: '',
      email: '',
      phone: '',
      day: '',
      month: 1, // Default to September (index 9)
      year: '',
      subscribe: ''
    },
    serverError: '',
    isMonthModalOpen: false,
    selectedMonth: 'Январь',
    months: [
      'Январь', 'Февраль', 'Март', 'Апрель',
      'Май', 'Июнь', 'Июль', 'Август',
      'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
    ],
    canResendCode: false,
    timer: null,
    remainingTime: 0,
    formattedTime: '00:00',

  }),
}
</script>
